// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_13-2";
export var blackBorderOnHover = "_13-7";
export var cell = "_13-6";
export var cellContainer = "_13-3";
export var checked = "_13-8";
export var disabled = "_13-5";
export var featuredIconCellContainer = "_13-9";
export var featuredIconTextContainer = "_13-b";
export var featuredIconWrapper = "_13-a";
export var noBorder = "_13-c";
export var orangeSelectedRow = "_3c-3";
export var overflowableText = "_13-0";
export var overflowableTextContainer = "_13-1";
export var row = "_14-0";
export var rowCheckboxCell = "_13-4";
export var selectableTable = "_3c-2";